"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useUpload_1 = __importDefault(require("@opsbase/react-gql-hooks/uploadfile/useUpload"));
const react_1 = require("react");
const uuid = __importStar(require("uuid"));
const imageMapper = (z, data) => z.fileName === data.fileName ? Object.assign(Object.assign({}, z), data) : z;
const arrayReducer = (prev, { type, data, index, mapper, newData, merger }) => {
    prev = prev !== null && prev !== void 0 ? prev : [];
    switch (type) {
        case 'add':
            return [...prev, data];
        case 'edit':
            return [...prev].map(z => mapper(z, data));
        case 'remove':
            return [...prev].filter((_, i) => i !== index);
        case 'reset':
            return newData;
        case 'merge':
            return merger(prev, newData);
    }
    return prev;
};
const getExtnFromFilename = (str) => {
    if (!(str === null || str === void 0 ? void 0 : str.length) || typeof str !== 'string')
        return '';
    const comps = str.split('.');
    if (comps.length === 1)
        return str;
    return `.${comps[comps.length - 1]}`;
};
const useManyImages = ({ photos, images: propsImages, onImagesChange }) => {
    var _a, _b;
    const [hideEditor, setHideEditor] = (0, react_1.useState)(true);
    const [resolvedImages, mutateResolvedImages] = (0, react_1.useReducer)(arrayReducer, (_a = propsImages !== null && propsImages !== void 0 ? propsImages : photos === null || photos === void 0 ? void 0 : photos.split(',').filter(z => z).map(z => ({ fileName: z }))) !== null && _a !== void 0 ? _a : []);
    // IHS-1428: this is probably needed, but it is creating other issues. Commenting for now
    // useEffect(() => {
    // if (!photos && (!propsImages || !propsImages.length) && resolvedImages?.length)
    // mutateResolvedImages({ type: 'reset', newData: propsImages })
    // else mutateResolvedImages({ type: 'merge', newData: propsImages, merger: imageMerger })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [propsImages, photos])
    const len = ((_b = resolvedImages === null || resolvedImages === void 0 ? void 0 : resolvedImages.length) !== null && _b !== void 0 ? _b : 0) - 1;
    const handleCancel = (0, react_1.useCallback)(() => {
        mutateResolvedImages({
            type: 'remove',
            index: len,
        });
        setHideEditor(true);
    }, [len]);
    const upload = (0, useUpload_1.default)();
    const handleAccept = (0, react_1.useCallback)((dataUrl) => __awaiter(void 0, void 0, void 0, function* () {
        const editingImage = resolvedImages[len];
        editingImage.imageData = dataUrl;
        mutateResolvedImages({
            type: 'edit',
            data: { fileName: editingImage.fileName, loading: true, editing: false },
            mapper: imageMapper,
        });
        setHideEditor(true);
        const result = yield upload({
            fileName: editingImage.fileName,
            userImage: editingImage.imageData,
        });
        mutateResolvedImages({
            type: 'edit',
            data: Object.assign(Object.assign({}, result), { loading: false }),
            mapper: imageMapper,
        });
    }), [resolvedImages, len, upload]);
    const addImage = (0, react_1.useCallback)((imageData, origFileName) => {
        const fileName = `${uuid.v4()}${getExtnFromFilename(origFileName)}`;
        console.log(fileName, origFileName);
        mutateResolvedImages({
            type: 'add',
            data: { fileName, imageData, editing: true },
        });
        setHideEditor(false);
    }, []);
    const deleteImage = (0, react_1.useCallback)(index => {
        mutateResolvedImages({ type: 'remove', index });
    }, []);
    (0, react_1.useEffect)(() => onImagesChange === null || onImagesChange === void 0 ? void 0 : onImagesChange(resolvedImages), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [resolvedImages]);
    const resetImages = (0, react_1.useCallback)(newImages => {
        mutateResolvedImages({ type: 'reset', newData: newImages });
    }, []);
    return (0, react_1.useMemo)(() => ({
        deleteImage,
        addImage,
        hideEditor,
        setHideEditor,
        handleAccept,
        handleCancel,
        resolvedImages,
        resetImages,
    }), [addImage, deleteImage, handleAccept, handleCancel, hideEditor, resetImages, resolvedImages]);
};
exports.default = useManyImages;
